// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-CustomViewDialogHeaderForSingleCustomView-module-customViewDialogHeaderForSingleCustomView {
	background: var(--Grey100);
	-ms-flex-pack: justify;
	    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/CustomViewDialogHeaderForSingleCustomView.module.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,sBAA8B;KAA9B,8BAA8B;AAC/B","sourcesContent":[".customViewDialogHeaderForSingleCustomView {\n\tbackground: var(--Grey100);\n\tjustify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customViewDialogHeaderForSingleCustomView": `csi-middleware-customView-CustomViewDialogHeaderForSingleCustomView-module-customViewDialogHeaderForSingleCustomView`
};
module.exports = ___CSS_LOADER_EXPORT___;
